module.exports = __webpack_public_path__ + "img/logo_white.027a91e8.png";